import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function EstadoEstudiosToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class EstadoEstudiosForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<EstadoEstudiosToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.estadoEstudiosEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.estadoEstudiosEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.estadoEstudiosPt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(EstadoEstudiosForm);
